import { Navigate, useOutlet, useLocation } from "react-router-dom";
import { Link as ReactLink } from "react-router-dom";
import { Box, Unstable_Grid2 as Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { selectAuth } from "@/app/features/auth/authSlice";

const HomeLayout = () => {
  const auth = useSelector(selectAuth);
  const outlet = useOutlet();
  const location = useLocation();

  // Hide header on login, forgot password, and reset password pages
  const isAuthPage = location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname.startsWith("/reset-password/");

  if (auth.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flex: "1 1 auto",
      }}
    >
      <Grid container sx={{ flex: "1 1 auto" }}>
        <Grid
          xs={12}
          lg={12}
          sx={{
            backgroundColor: "background.paper",
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          {!isAuthPage && (
            <Box
              component="header"
              sx={{
                left: 0,
                p: 3,
                position: "fixed",
                top: 0,
                width: "100%",
              }}
            >
              <Box
                component={ReactLink}
                to="/"
                sx={{
                  display: "inline-flex",
                  height: 100,
                  width: 200,
                }}
              >
                <img
                  style={{
                    maxWidth: "100%",
                  }}
                  src="/assets/logos/opdox_1.png"
                  alt="beep"
                />
              </Box>
            </Box>
          )}
          <Box
            sx={{
              marginTop: isAuthPage ? 0 : "100px",
            }}
          >
            {outlet}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomeLayout;
